import { HttpService, DownloadProvider} from "./common";
import {
  CourseAttendeeCollectionModel,
  CourseAttendeeLookupModel,
  CertifyExistingCourseAttendeeModel,
  CertifyNewCourseAttendeeModel,
  FileDownloadModel,
  PagedCollectionFilter,
  PagedCollection,
} from "@/core/models";

export const CourseAttendeeService = {
  async dowmloadCertificatePdf(
    userId: number,
    courseAttendeeId: number,
    locale: string) {

    const response = await HttpService.getData<FileDownloadModel>(
      `users/${userId}/certificate/${courseAttendeeId}/download/${locale}`);

    DownloadProvider.downloadResponse(response);
  },

  getListLookupData(filter: PagedCollectionFilter) {
    return HttpService.getData<CourseAttendeeLookupModel>(
      "course-attendees/list-lookup-data",
      { params: filter });
  },

  filter(filter: PagedCollectionFilter) {
    return HttpService.getData<PagedCollection<CourseAttendeeCollectionModel>>(
      "course-attendees/filter",
      { params: filter });
  },

  certifyExisting(model: CertifyExistingCourseAttendeeModel) {
    return HttpService.postData("course-attendees/certify", model);
  },

  addNewAndCertify(model: CertifyNewCourseAttendeeModel) {
    return HttpService.putData("course-attendees/certify", model);
  }
};
